'use strict';
module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/shortid/index.js
// module id = 465
// module chunks = 4 6 7 8 9 10 12 21 22 23 24 27 56 57